import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const CORE_NAV_PROMO_SIGNAL_I18N_NAMESPACE =
  '@mc/next/experiments/mccerts-2851_v1_core_nav_promo_signal'

export const i18nInstance = registerI18nResources({
  namespace: CORE_NAV_PROMO_SIGNAL_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
